"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BitstraysSeederFactory = void 0;
const contracts_1 = require("@ethersproject/contracts");
class BitstraysSeederFactory extends contracts_1.ContractFactory {
    constructor(signer) {
        super(_abi, _bytecode, signer);
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static connect(address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.BitstraysSeederFactory = BitstraysSeederFactory;
const _abi = [
    {
        inputs: [
            {
                internalType: "uint256",
                name: "bitstrayId",
                type: "uint256",
            },
            {
                internalType: "contract IBitstraysDescriptor",
                name: "descriptor",
                type: "address",
            },
        ],
        name: "generateSeed",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint48",
                        name: "background",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "arms",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "shirt",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "motive",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "head",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "eyes",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "mouth",
                        type: "uint48",
                    },
                ],
                internalType: "struct IBitstraysSeeder.Seed",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "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";
